/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SpokenLanguage } from './';
import {
    SpokenLanguageFromJSON,
    SpokenLanguageFromJSONTyped,
    SpokenLanguageToJSON,
} from './';
import type { WorkplacePreferences } from './';
import {
    WorkplacePreferencesFromJSON,
    WorkplacePreferencesFromJSONTyped,
    WorkplacePreferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateAboutSectionRequest
 */
export interface UpdateAboutSectionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAboutSectionRequest
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAboutSectionRequest
     */
    industryExpertises: Array<string>;
    /**
     * 
     * @type {Array<SpokenLanguage>}
     * @memberof UpdateAboutSectionRequest
     */
    languages: Array<SpokenLanguage>;
    /**
     * 
     * @type {WorkplacePreferences}
     * @memberof UpdateAboutSectionRequest
     */
    workplacePreferences: WorkplacePreferences;
}

/**
 * Check if a given object implements the UpdateAboutSectionRequest interface.
 */
export function instanceOfUpdateAboutSectionRequest(value: object): value is UpdateAboutSectionRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('industryExpertises' in value) || value['industryExpertises'] === undefined) return false;
    if (!('languages' in value) || value['languages'] === undefined) return false;
    if (!('workplacePreferences' in value) || value['workplacePreferences'] === undefined) return false;
    return true;
}

export function UpdateAboutSectionRequestFromJSON(json: any): UpdateAboutSectionRequest {
    return UpdateAboutSectionRequestFromJSONTyped(json, false);
}

export function UpdateAboutSectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAboutSectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'industryExpertises': json['industryExpertises'],
        'languages': ((json['languages'] as Array<any>).map(SpokenLanguageFromJSON)),
        'workplacePreferences': WorkplacePreferencesFromJSON(json['workplacePreferences']),
    };
}

export function UpdateAboutSectionRequestToJSON(value?: UpdateAboutSectionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'industryExpertises': value['industryExpertises'],
        'languages': ((value['languages'] as Array<any>).map((v) => SpokenLanguageToJSON(v))),
        'workplacePreferences': WorkplacePreferencesToJSON(value['workplacePreferences']),
    };
}

